var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_616_306013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.59766 12.3478C6.32098 12.624 6.18281 12.9869 6.18281 13.3494C6.18281 13.7466 6.47789 14.7521 7.60234 14.7521C7.97055 14.7521 8.33867 14.6184 8.60703 14.3509L16.9937 5.98765C17.5195 5.46343 17.8098 4.76577 17.8098 4.02397C17.8098 2.48765 16.5617 1.2478 15.0238 1.2478C14.3109 1.2478 13.5977 1.51851 13.0551 2.0603L3.40352 11.6837C2.59453 12.4908 2.19023 13.5505 2.19023 14.6103C2.19023 15.7708 3.05469 18.708 6.33867 18.708C7.41406 18.708 8.48906 18.3169 9.27266 17.5349L16.5109 10.3162C16.6334 10.1941 16.7937 10.133 16.9539 10.133C17.3146 10.133 17.5809 10.4278 17.5809 10.758C17.5809 10.918 17.5196 11.0779 17.3972 11.1998L10.1589 18.4186C9.13672 19.4416 7.78125 20.0001 6.33984 20.0001C3.33477 20.0001 0.9375 17.5728 0.9375 14.6134C0.9375 13.2337 1.46406 11.8537 2.51719 10.8033L12.1695 1.18218C12.9566 0.396631 13.991 0.00366211 15.0254 0.00366211C17.2461 0.00366211 19.0645 1.79233 19.0645 4.03101C19.0645 5.10718 18.6437 6.11812 17.8812 6.87866L9.49453 15.2419C8.97305 15.7619 8.28828 16.022 7.60391 16.022C6.15937 16.022 4.93125 14.8638 4.93125 13.3568C4.93125 12.674 5.19187 11.9912 5.71328 11.4708L11.6859 5.51382C11.8084 5.39175 11.9688 5.33069 12.1293 5.33069C12.4693 5.33069 12.7562 5.60476 12.7562 5.95569C12.7562 6.11562 12.695 6.27554 12.5726 6.39749L6.59766 12.3478Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_616_306013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.6fccca759ba8647a691f5d9801b0fa57.svg";
export { ForwardRef as ReactComponent };